import { useState, useEffect } from 'react';
import {
    Grid, IconButton, Tooltip, Stack, Snackbar, Alert,
    MenuItem, ListItemText, Checkbox
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Select from '@mui/material/Select';
import SaveIcon from '@mui/icons-material/Save';

export const InternalUserGrid = ({
    paginationModel,
    setPaginationModel,
    roles,
    handleSave
}: any) => {
    const [successMessage, setSuccessMessage] = useState(false);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        setRows(paginationModel.data);
    }, [paginationModel.data])

    const handleRolesChange = (id, selectedRoleIds) => {
        setRows((prevRows) =>
            prevRows.map((row) => {
                if (row.id === id) {
                    const updatedRoles = selectedRoleIds.map((roleID) => ({
                        userId: id,
                        roleID,
                    }));
                    return { ...row, internalUserRoles: updatedRoles };
                }
                return row;
            })
        );
    };

    const saveRender = (props: any) => {
        const { row } = props;
        return (
            <div style={{ display: 'inline-flex' }}>
                <Tooltip title="Save">
                    <IconButton color="primary" onClick={() => handleSave(row)}>
                        <SaveIcon />
                    </IconButton>
                </Tooltip>
            </div>
        );
    }

    const renderInternalEmail = (props: any) => {
        const { row } = props;
        return (
            <div>
                <Tooltip title={row.email} >
                    <span>{row.email}</span>
                </Tooltip>
            </div>
        )
    }

    const renderInternalFirstName = (props: any) => {
        const { row } = props;
        return (
            <div>
                <Tooltip title={row.firstname} >
                    <span>{row.firstname}</span>
                </Tooltip>
            </div>
        )
    }

    const renderInternalLastName = (props: any) => {
        const { row } = props;
        return (
            <div>
                <Tooltip title={row.lastname} >
                    <span>{row.lastname}</span>
                </Tooltip>
            </div>
        )
    }

    const interManageUserColumns = [
        {
            field: 'firstname',
            headerName: 'First Name',
            minWidth: 150,
            renderCell: renderInternalFirstName
        },
        {
            field: 'lastname',
            headerName: 'Last Name',
            minWidth: 150,
            renderCell: renderInternalLastName
        },
        {
            field: 'email',
            headerName: 'Email',
            minWidth: 300,
            renderCell: renderInternalEmail
        },
        {
            field: 'roles',
            headerName: 'Role',
            minWidth: 300,
            renderCell: (params: any) => {
                const selectedRoles = params.row.internalUserRoles.map((role) => role.roleID);
                return (
                    <Select
                        multiple
                        size="small"
                        value={selectedRoles}
                        onChange={(e) =>
                            handleRolesChange(params.row.id, e.target.value)
                        }
                        renderValue={(selected) =>
                            selected
                                .map(
                                    (roleId) =>
                                        roles.find((role) => role.id === roleId)?.name
                                )
                                .join(", ")
                        }
                        style={{ width: "100%" }}
                    >
                        {roles.map((role) => (
                            <MenuItem key={role.id} value={role.id}>
                                <Checkbox checked={selectedRoles.includes(role.id)} />
                                <ListItemText primary={role.name} />
                            </MenuItem>
                        ))}
                    </Select>
                )
            }
        },
        {
            field: 'action',
            headerName: 'Action',
            minWidth: 80,
            renderCell: saveRender
        }
    ];

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                    <DataGrid
                        autoHeight
                        sx={{
                            '.MuiDataGrid-columnHeaders': {
                                backgroundColor: '#003883',
                                color: '#fff'
                            },
                            '.MuiDataGrid-menuIcon .MuiSvgIcon-root': {
                                color: '#fff'
                            },
                            '.MuiDataGrid-iconButtonContainer .MuiSvgIcon-root': {
                                color: '#fff'
                            }
                        }}
                        columns={interManageUserColumns}
                        rows={rows}
                        rowCount={paginationModel.total}
                        loading={paginationModel.isLoading}
                        page={paginationModel.page - 1}
                        pageSize={paginationModel.pageSize}
                        pagination
                        paginationMode="server"
                        onPageChange={(newPage: any) => {
                            setPaginationModel(old => ({ ...old, page: newPage + 1 }))
                        }}
                    />
                </Grid>
            </Grid>
            <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
                <Snackbar open={successMessage} autoHideDuration={6000} onClose={() => setSuccessMessage(false)}>
                    <Alert severity="success" onClose={() => setSuccessMessage(false)}><b>Successfully Updated!</b></Alert>
                </Snackbar>
            </Stack>
        </div >
    );
}
